import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core'
import {ComentarioCasoService, ComentarioCasoModel} from 'src/app/services/comentariosCasos.service'
import { Socket } from 'ngx-socket-io';

@Component({
  selector:'app-comentario-caso',
  templateUrl: './comentario-caso.component.html',
  styleUrls: ['./comentario-caso.component.css']
})
export class ComentarioCasoComponent implements OnInit {
  @Input('idCaso') idCaso: string
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();
  comentarios: string[] = []
  comentario: string = ''

  constructor(
    private socket: Socket,
    public comentarioService: ComentarioCasoService
  ) {}

  ngOnInit() {
    this.socket.on('recarga_comentarios', (msj: { ok: boolean }) => {
      this.getComentarios()
    })
    this.getComentarios()
  }

  getComentarios(){
    this.comentarioService.get(this.idCaso)
      .subscribe(async(response: any)=>{
        console.log("idCaso",response)
        this.comentarios = response
        setTimeout(()=>{
          let div = document.getElementById('comentarios')
          div.scrollTop = div.scrollHeight + div.clientHeight
        },100)
      })
  }

  createComentario(){
 
    const comentario: ComentarioCasoModel = {
      idCaso: this.idCaso,
      nombreUsuarioComentario: sessionStorage.getItem('correo'),
      comentarioText: this.comentario,
      createdAt: new Date(),
      deleted: false
    }
    this.comentarioService.post(comentario)
      .subscribe((resp:any)=>{
        console.log('Creando comentario',resp)
      })
    this.comentario = ''
  }

  close(){
    this.closeEvent.emit(null)
  }

}
